module.exports = __webpack_public_path__ + "img/2.06f9bbf2.png";